export const isRussiaWarLP = (pageId: string) => {
  return ['RuBy Service Suspended', 'Stand With Ukraine'].includes(pageId)
}
